import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';

import { ListConsumablesQuery } from '@/core/domain/operational/Consumables/Consumables.types';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';

function ConsumablesExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListConsumablesQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={12} lg={8} xxl={4}>
        <Input
          value={queryParams?.manufacturingCode}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, manufacturingCode: value }))
          }
          placeholder={intl.formatMessage({
            id: 'consumables.entity.manufacturerCode',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={4}>
        <Input
          value={queryParams?.barCode}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, barCode: value }))
          }
          placeholder={intl.formatMessage({
            id: 'consumables.entity.barCode',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={4}>
        <Input
          value={queryParams?.sku}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, sku: value }))
          }
          placeholder={intl.formatMessage({
            id: 'consumables.entity.sku',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={4}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default ConsumablesExtraFilters;
